import { useRef } from "react";
import ModalPop from "./ModalPop";

const Service = () => {
  const serviceList = [
    {
      img: "/images/service1.png",
      name: "누수탐지",
      txt2: "보이지 않는 누수 원인을 정밀",
      txt3: "장비로 찾아내는 서비스",
      link: "/",
    },
    {
      img: "/images/service2.png",
      name: "누수공사",
      txt2: "누수 원인을 보수하고 배관을",
      txt3: "복구하는 공사 서비스다",
      link: "/",
    },
  ];

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <div
      id="service"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 text-center lg:text-left"
    >
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div
        id="title"
        className="relative w-full h-fit text-center mb-5 xl:mb-10"
      >
        <p className="lg:text-lg xl:text-xl text-secondary">
          스마트 누수장인의 서비스 목록
        </p>
        <h2 className="font-light text-primary xl:text-5xl">
          서비스 목록 안내
        </h2>
      </div>
      <div className="relative w-full h-fit max-w-screen-md mx-auto grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-5">
        {serviceList.map((v, i) => (
          <div key={i} data-aos="fade-up" className="relative w-full h-full ">
            <div className="relative w-full h-fit border-[#b8e9ff] pt-5 px-7 rounded-3xl bg-[#b8e9ff] btn6 inline-block ">
              <h2 className="text-secondary gbold">{v.name}</h2>
              <p className="text-[#296bef] lg:text-xl">{v.txt2}</p>
              <p className="text-[#296bef] lg:text-xl">{v.txt3}</p>
              <button
                type="button"
                onClick={() => window.open(v.link)}
                className="relative w-fit h-fit py-1 bg-secondary px-10 text-white mt-3 rounded-lg"
              >
                <p className="lg:text-xl pt-1">작업사례 보러가기</p>
              </button>
              <button
                type="button"
                onClick={openfunc}
                className="relative w-fit h-fit py-1 bg-[#296bef] px-10 text-white mt-2 rounded-lg"
              >
                <p className="lg:text-xl pt-1">견적문의 요청하기</p>
              </button>
              <div className=" relative w-full h-full pt-6 overflow-hidden">
                <img
                  src={v.img}
                  alt="누수비용"
                  className="!relative w-auto h-full max-h-32 2xl:max-h-44 transition duration-300 mx-auto"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
